import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ResetpasswordForm } from '../../components/forms/resetpasswordForm/resetpasswordForm.component';

@Component({
  selector: 'resetpassword',
  standalone: true,
  imports: [
    ResetpasswordForm,
  ],
  templateUrl: './resetpassword.component.html',
})
export class ResetpasswordPage { }
